export const AUTH_ERROR_QUERY_PARAM = 'authError'
export const AUTH_PROVIDER_QUERY_PARAM = 'authProvider'
export const AUTH_NO_CONTENTINTEGRATOR_SEATS = 'no-contentintegrator-seats'
export const KEYCLOAK_IDP_HINT_STORAGE_KEY = 'keycloakIdpHint'

export const IDENTITY_PROVIDER_LABELS: Record<string, string> = {
  rechtsorde: 'Rechtsorde',
  li: 'Legal Intelligence',
  oidc: 'SURFconext',
}
